import { render, staticRenderFns } from "./ReminderButton.vue?vue&type=template&id=a49b0be4"
import script from "./ReminderButton.vue?vue&type=script&lang=ts"
export * from "./ReminderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports